export default "__VITE_ASSET__Z5nwe1Bl__"